import React from 'react';
import { SectionHeading } from 'web-ui-components/lib/typography/headings';
import { BulletList } from 'web-ui-components/lib/typography/lists';
import { WebsiteLink } from 'web-ui-components/lib/actions/links';
import { Content } from '../../../infrastructure/content';
import { getHyperlink } from '../../../utils';

const DocumentsForYou = ({
  bankId,
  offer,
  termsConditionsRef,
  tariffGuideRef,
  fscsRef,
  digitalServicesTermsRef,
  onlineTarrifRef
}) => (
  <Content>
    {({
      documentsForYou = '',
      termsAndConditionsForBusiness,
      businessBankingTariffGuide,
      FSCSInfoSheet,
      emailDocuments,
      keyFeatureAccount,
      keyFeatureChoiceAccount,
      businessCurrentAccountCBHyperlink,
      businessCurrentAccountYBHyperlink,
      businessChoiceAccountCBHyperlink,
      businessChoiceAccountYBHyperlink,
      fullStop,
      digitalServicesTermsRefInfoSheet,
      onlineTarrifRefInfoSheet
    }) => (
      <div>
        <SectionHeading>{documentsForYou}</SectionHeading>
        <BulletList
          items={[
            <WebsiteLink
              linkText={termsAndConditionsForBusiness}
              url={termsConditionsRef}
              willOpenNewWindow
            />,
            <WebsiteLink
              linkText={businessBankingTariffGuide}
              url={tariffGuideRef}
              willOpenNewWindow
            />,
            <WebsiteLink linkText={FSCSInfoSheet} url={fscsRef} willOpenNewWindow />,
            <WebsiteLink
              linkText={digitalServicesTermsRefInfoSheet}
              url={digitalServicesTermsRef}
              willOpenNewWindow
            />,
            <WebsiteLink
              linkText={onlineTarrifRefInfoSheet}
              url={onlineTarrifRef}
              willOpenNewWindow
            />
          ]}
        />
        <p>
          {emailDocuments}
          {offer && offer.toLowerCase() === keyFeatureChoiceAccount.toLowerCase() ? (
            <WebsiteLink
              linkText={keyFeatureChoiceAccount}
              url={getHyperlink(
                businessChoiceAccountCBHyperlink,
                businessChoiceAccountYBHyperlink,
                bankId
              )}
              willOpenNewWindow
            />
          ) : (
            <WebsiteLink
              linkText={keyFeatureAccount}
              url={getHyperlink(
                businessCurrentAccountCBHyperlink,
                businessCurrentAccountYBHyperlink,
                bankId
              )}
              willOpenNewWindow
            />
          )}
          {fullStop}
        </p>
      </div>
    )}
  </Content>
);

export default DocumentsForYou;
